import { useAdmin } from './AdminContext';
import { ContentCard } from './AdminShared';
import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const AdminArtistsTab = () => {
  const { artists, featureItem, unfeatureItem, banItem, unbanItem, deleteArtist } = useAdmin();
  return (
    <>
      <h2 className="text-xl font-semibold mb-4">Manage Artists ({artists.length})</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {artists.map(artist => (
          <div key={artist.id}>
            <ContentCard item={artist} type="artist"
              onFeature={(id) => featureItem('artist', id)} onUnfeature={(id) => unfeatureItem('artist', id)}
              onBan={(id) => banItem('artist', id)} onUnban={(id) => unbanItem('artist', id)} />
            <Button size="sm" variant="ghost" className="w-full text-destructive hover:text-destructive text-xs mt-1" onClick={() => deleteArtist(artist.id)}><Trash2 size={12} className="mr-1" /> Delete</Button>
          </div>
        ))}
      </div>
    </>
  );
};

export const AdminFoodTrucksTab = () => {
  const { foodTrucks, featureItem, unfeatureItem, banItem, unbanItem, deleteFoodTruck } = useAdmin();
  return (
    <>
      <h2 className="text-xl font-semibold mb-4">Manage Food Trucks ({foodTrucks.length})</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {foodTrucks.map(truck => (
          <div key={truck.id}>
            <ContentCard item={truck} type="food-truck"
              onFeature={(id) => featureItem('food-truck', id)} onUnfeature={(id) => unfeatureItem('food-truck', id)}
              onBan={(id) => banItem('food-truck', id)} onUnban={(id) => unbanItem('food-truck', id)} />
            <Button size="sm" variant="ghost" className="w-full text-destructive hover:text-destructive text-xs mt-1" onClick={() => deleteFoodTruck(truck.id)}><Trash2 size={12} className="mr-1" /> Delete</Button>
          </div>
        ))}
      </div>
    </>
  );
};

export const AdminVendorsTab = () => {
  const { vendors, featureItem, unfeatureItem, banItem, unbanItem, deleteVendor } = useAdmin();
  return (
    <>
      <h2 className="text-xl font-semibold mb-4">Manage Vendors ({vendors.length})</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {vendors.map(vendor => (
          <div key={vendor.id}>
            <ContentCard item={vendor} type="vendor"
              onFeature={(id) => featureItem('vendor', id)} onUnfeature={(id) => unfeatureItem('vendor', id)}
              onBan={(id) => banItem('vendor', id)} onUnban={(id) => unbanItem('vendor', id)} />
            <Button size="sm" variant="ghost" className="w-full text-destructive hover:text-destructive text-xs mt-1" onClick={() => deleteVendor(vendor.id)}><Trash2 size={12} className="mr-1" /> Delete</Button>
          </div>
        ))}
      </div>
    </>
  );
};
